import React from 'react'
import { useIntl } from 'react-intl'
import {
  Button,
  MODAL_SIZE_SM,
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot
} from 'mailup-web-components'
import { modalAlertMessageUpdate } from '../recoil/state/modal'
import { useRecoilState, useSetRecoilState } from 'recoil'
// import { messageState } from '../recoil/state/message'
import { pageState } from '../recoil/state/page'

const ModalAlertMessageUpdate = () => {
  const intl = useIntl()
  const [open, setOpen] = useRecoilState(modalAlertMessageUpdate)
  // const [{ canQuickSend, canSend}, setMessageProperty] = useRecoilState(messageState)
  // const setMessageProperty = useSetRecoilState(messageState)
  const setPageProperty = useSetRecoilState(pageState)

  const handleClose = () => {
    setOpen(false)

    // setMessageProperty(prev => ({
    //   ...prev,
    //   canQuickSend: false,
    //   canSend: false
    // }))

    setPageProperty(prev => ({
      ...prev,
      loading: false
    }))
  }

  return (
    <Modal
      data-mu-test='modal-confirm-leave'
      show={open}
      onClose={handleClose}
      showClose
      closeOnOverlayClick={false}
      size={MODAL_SIZE_SM}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.EmailMessageList.MessageIsOnSentWarningTitle'
        })}
      />
      <ModalBody>
        <p>
          {intl.formatMessage({
            id: 'Load.EmailMessageList.MessageIsOnSentWarning'
          })}
        </p>
      </ModalBody>
      <ModalFoot>
        <Button
          kind='primary'
          onClick={handleClose}
          data-mu-test='modal-alert-message-update-button-confirm'
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Ok' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalAlertMessageUpdate
